import React, { useCallback, useEffect } from 'react';
import { observer } from 'mobx-react';
import { StackLayout, Text, Button, useModalStore } from '@wemogy/reactbase';
import RoleList from '../roleList/RoleList';
import useAuthorizationStore from '../../../hooks/UseAuthorizationStore';
import ManageRoleModal from '../manageRoleModal/ManageRoleModal';
import Role from '../../../dataLayer/models/Role';
var RoleManagement = function (props) {
    var tenantId = props.tenantId;
    var authorizationStore = useAuthorizationStore();
    var roleStore = authorizationStore.roleStore;
    var modalStore = useModalStore();
    var handleAddRolePress = useCallback(function () {
        modalStore.openModal('manageRoleModal', {
            role: Role.create({
                tenantId: tenantId
            }), mode: 'create'
        });
    }, []);
    useEffect(function () {
        roleStore.queryTenantRoles(tenantId);
    }, []);
    console.log('authorizationStore.getTenantRoles(tenantId)', roleStore.getTenantRoles());
    var tenantRoles = roleStore.getTenantRoles();
    console.log('tenantRoles', tenantRoles);
    return (React.createElement(StackLayout, { borderRadius: true, border: 0.125, padding: true, borderColor: "grey500" },
        React.createElement(StackLayout, { horizontal: true, spaceBetween: true, vCenter: true, marginBottom: true },
            React.createElement(Text, null, "authorization.txt_roleManagementHeadline"),
            React.createElement(Button, { onPress: handleAddRolePress }, "authorization.btn_addNewRole")),
        React.createElement(RoleList, { roles: tenantRoles }),
        React.createElement(ManageRoleModal, null)));
};
export default observer(RoleManagement);
//# sourceMappingURL=RoleManagement.js.map